import React, { useEffect, useState } from "react";
import { Form, Radio, Input, Space, Checkbox, Row, Col } from "antd";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import { values } from "lodash";

interface props {
  activeQuestion?: any;
  form?: any;
  placeholder?: string;
  currentRoutine?: string[];
  inputType?: string;
  setKeepUsing?: any;
  checkboxVisible?: boolean;
  setDiscardProductError?: any;
  keepUsingRoutineProduct?: any;
  setRawKeepUsing?: any;
}

const SingleSelectWithInput: React.FC<props> = (props) => {
  const {
    placeholder,
    currentRoutine,
    inputType,
    setKeepUsing,
    checkboxVisible,
    setDiscardProductError,
    keepUsingRoutineProduct,
    setRawKeepUsing,
  } = props;
  const [inputVisible, setInputVisible] = useState(checkboxVisible);
  const [labelActive, setLabelActive] = useState(false);
  const [inputValue, setInputValue] = useState<any>();
  useEffect(() => {
    setDiscardProductError(false);
    if (keepUsingRoutineProduct?.length) {
      setInputVisible(true);
    }
  }, []);

  const handleOnChange = (e: any) => {
    setInputValue(e.target.value);
    setDiscardProductError(false);
    props.form.setFieldsValue({
      [props?.activeQuestion?.data?.question]: e.target.value,
    });
  };

  const onChange = (values: CheckboxValueType[]) => {
    console.log("currentRoutine", currentRoutine, values);
    setRawKeepUsing(values);
    const checkedValues = values.map((item: any) => item.split("-+")[0].trim());
    setKeepUsing(checkedValues);
    props.form.setFieldsValue({
      [props?.activeQuestion?.data?.question]: checkedValues,
    });
  };

  return (
    <div className="answer-input-wrapper">
      <Form.Item
        className={`questionlist-radio questionlist-radio--with-input `}
        name={props?.activeQuestion?.data?.question}
        rules={[
          { required: true, message: "You have to select alteast one option" },
        ]}
      >
        <Radio.Group>
          <Space direction="vertical">
            {/* {props?.activeQuestion?.layout==="horizontal"} */}
            <Row gutter={25}>
              {props?.activeQuestion?.options.map(
                (option: any, index: any, arr: any) => {
                  const RadioComponent = () => {
                    return (
                      <Radio
                        value={option}
                        key={index}
                        className={
                          (inputValue?.length ||
                            inputValue?.length === 0 ||
                            keepUsingRoutineProduct?.length ||
                            keepUsingRoutineProduct?.length === 0) &&
                          props?.activeQuestion?.options?.length === index + 1
                            ? "keep-using-active"
                            : ""
                        }
                        onClick={(e: any) => {
                          props.form.setFieldsValue({
                            [props?.activeQuestion?.data?.question]: option,
                          });
                          if (
                            e.target.value ==
                            "I want to swap all of my skincare."
                          ) {
                            setRawKeepUsing([]);
                          } else {
                            setRawKeepUsing(currentRoutine);
                          }
                          console.log("click", e);
                          setInputValue(undefined);
                          setKeepUsing(undefined);
                          setDiscardProductError(false);
                          if (index + 1 === arr.length) {
                            // setLabelActive(true);
                            setInputVisible(true);
                          } else {
                            setInputVisible(false);
                            // setLabelActive(false);
                          }
                        }}
                      >
                        {option}
                      </Radio>
                    );
                  };
                  return (
                    <React.Fragment key={index}>
                      {props?.activeQuestion?.layout === "horizontal" ? (
                        <Col
                          span={24}
                          sm={12}
                          lg={8}
                          className="mb-15"
                          key={index}
                        >
                          <RadioComponent />
                        </Col>
                      ) : (
                        <Col span={24} className="mb-15" key={index}>
                          <RadioComponent />
                        </Col>
                      )}
                    </React.Fragment>
                  );
                }
              )}
            </Row>
          </Space>

          {inputVisible ? (
            <>
              {inputType === "select" ? (
                <div className="questionlist-checkbox__wrapper">
                  <h2>Check the products that you would like to keep using</h2>
                  <div className="questionlist-checkbox questionlist-checkbox--routine-product">
                    <Checkbox.Group
                      onChange={onChange}
                      style={{ width: "100%" }}
                    >
                      <Row style={{ width: "100%" }}>
                        {currentRoutine?.map((product, i) => {
                          const partsOfProduct = product?.split("-+");
                          const brandName = partsOfProduct[2];
                          const withBrandName = partsOfProduct[0];
                          const stringWithoutLastPart = withBrandName;
                          return product ? (
                            <Col span={24} key={i}>
                              <Checkbox value={product} key={i}>
                                {brandName && (
                                  <span className="brand-bold">
                                    {brandName}&nbsp;-&nbsp;
                                  </span>
                                )}
                                <span className="brand-normal">
                                  {stringWithoutLastPart}
                                </span>
                              </Checkbox>
                            </Col>
                          ) : null;
                        })}
                      </Row>
                    </Checkbox.Group>
                  </div>
                </div>
              ) : (
                <Input
                  className={`${inputVisible ? "input--option-active" : ""}`}
                  placeholder={placeholder}
                  onChange={handleOnChange}
                />
              )}
            </>
          ) : null}
        </Radio.Group>
      </Form.Item>
    </div>
  );
};

export default SingleSelectWithInput;
